import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import Fetching from "@/components/Fetching/Fetching";

import classes from "./edit_multiple.module.scss";

const EditMultiple = ({ options, setOptions, handleChange, currentValue, currentLabel, needPermission = false }) => {
	const { user } = useSelector((state) => state.auth);
	const tools = user ? user.tools : [];
	const profiles = user ? user.profiles : [];

	useEffect(() => {
		if (currentValue) {
			setLocalValue(currentValue);
		}
	}, [currentValue]);

	const [localValue, setLocalValue] = useState("");
	const [localOptions, setLocalOptions] = useState(options);
	const [edit, setEdit] = useState(false);
	const [fetching, setFetching] = useState(false);

	useEffect(() => {
		setLocalOptions(options);
	}, [options]);

	const handleLocalChange = async () => {
		setEdit(false);
		setFetching(true);

		await handleChange(localValue);

		setFetching(false);
	};

	let hasPermission = true;
	if (needPermission && !(tools.find((tool) => tool.id === 19) && profiles.find((profile) => profile.id === 4))) {
		hasPermission = false;
	}

	const selectedValues = localValue ? localValue.split(",").map(decodeURIComponent).filter(Boolean) : [];

	const handleSelectChange = (values) => {
		const encoded = (values || []).map((v) => encodeURIComponent(v)).join(",");
		setLocalValue(encoded);
	};

	const handleCreateOption = (inputValue) => {
		const newOption = { value: inputValue, label: inputValue };
		const updatedOptions = [...localOptions, newOption];
		setLocalOptions(updatedOptions);
		if (setOptions) setOptions(updatedOptions);
		const updatedValues = [...selectedValues, inputValue];
		setLocalValue(updatedValues.map((v) => encodeURIComponent(v)).join(","));
	};

	const emptyLabel = hasPermission ? <div className={classes.add_button}>Agregar</div> : "";
	const displayLabel = currentLabel || emptyLabel;

	if (fetching) {
		return <Fetching topMargin={"0em"} />;
	}

	if (edit) {
		return (
			<div style={{ width: "98%" }}>
				<CustomInputSelect
					name="edit_multiple"
					options={localOptions}
					value={selectedValues}
					onChange={handleSelectChange}
					placeholder="Seleccione"
					isMulti
					isClearable={false}
					creatable={!!setOptions}
					onCreateOption={setOptions ? handleCreateOption : undefined}
					formatCreateLabel={(inputValue) => `Crear ${inputValue}`}
				/>

				<div className={classes.editable_button}>
					<button className={classes.button_cancel} onClick={() => setEdit(false)}>
						Cancelar
					</button>
					<button className={classes.button_confirm} onClick={handleLocalChange}>
						Guardar
					</button>
				</div>
			</div>
		);
	}

	return <span onClick={() => hasPermission && setEdit(true)}>{displayLabel}</span>;
};

export default EditMultiple;
